import React from 'react';
import { Link } from 'gatsby';

const PrenotaOra = ({ text }) => (
  <div className='prenota-ora'>
    <Link className='nav-link' to='/inizia'>
      {text || 'Inizia ora'}
    </Link>
  </div>
);

export default PrenotaOra;
